import React from 'react'
import type { IUserNotification } from 'types'

/** Stable interface — do NOT use ReturnType<typeof useNotificationsProviderValue> */
export interface NotificationsStore {
  unreadCount: number
  notifications: IUserNotification[]
  loading: boolean
  hasMore: boolean
  refreshUnreadCount: () => Promise<void>
  loadNotifications: (reset?: boolean) => Promise<void>
  markRead: (notification: IUserNotification) => Promise<void>
  dismiss: (notification: IUserNotification) => Promise<void>
  markAllRead: () => Promise<void>
}

/** Context generic stays EXACTLY the same everywhere */
type Ctx = NotificationsStore | undefined

/** Cache the Context on globalThis so HMR reuses the same object */
const KEY = '__APP__NotificationsContext'
const existing = (globalThis as any)[KEY] as React.Context<Ctx> | undefined

export const NotificationsContext: React.Context<Ctx> = existing ?? React.createContext<Ctx>(undefined)

if (!(globalThis as any)[KEY]) {
  ;(globalThis as any)[KEY] = NotificationsContext
}

/** Consumer hook */
export const useNotifications = (): NotificationsStore => {
  const ctx = React.useContext(NotificationsContext)
  if (!ctx) throw new Error('useNotifications can only be used within a Notifications context')
  return ctx
}

/** If this file changes, do a full reload to avoid stale consumer/provider splits */
if (import.meta.hot) {
  import.meta.hot.accept(() => import.meta.hot.invalidate())
}
